<template>
  <BaseTable title="Transaction" :columns="columns" :data="data" />
</template>

<script>
import { BaseTable } from "@/shared/ui";
import { columns } from "../data/constants";

export default {
  name: "TransactionsTable",
  components: { BaseTable },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { columns };
  },
};
</script>

<style lang="scss" scoped></style>
